// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IContributionActivityRecordResponseDto,
  IContributionAmountDetailsDto,
  IContributionRecordIdentifier,
  IContributionRequestDto,
  IContributionResponseDto,
  IContributionSearchResponseInfoDto,
  IContributionSegmentResponseDto,
  IEntityAttributeDto,
  IErrorDto,
  IGenericErrorDto,
  IPageChangesetChangeDto,
  IPayrollCalendarDto,
  IPayrollCalendarExtendedDto,
  IPayrollCalendarPartnerRequestDto,
  IPayrollCalendarReducedDto,
  IPayrollCalendarRequestDto,
  IPayrollCalendarResponseDto,
  IPayrollCalendarUpdateDto,
  IPayrollCalendarUpdatePartnerRequestDto,
  IPayrollCalendarUpdatePartnerResponseDto,
  IPayrollGroupDto,
  IPayrollGroupPatchRequestDto,
  IPayrollGroupRequestDto,
  IRecordTaxYearChangeCreateDto,
  IRecordTaxYearChangeResponseDto,
  IRecurringContributionResponseDto,
  IScheduledCalendarDto,
  IScheduledContributionRequestDto,
  IScheduledContributionResponseDto,
  IScheduledContributionUpdateDto,
} from '../models/index';
import {
    IContributionActivityRecordResponseDtoFromJSON,
    IContributionActivityRecordResponseDtoToJSON,
    IContributionAmountDetailsDtoFromJSON,
    IContributionAmountDetailsDtoToJSON,
    IContributionRecordIdentifierFromJSON,
    IContributionRecordIdentifierToJSON,
    IContributionRequestDtoFromJSON,
    IContributionRequestDtoToJSON,
    IContributionResponseDtoFromJSON,
    IContributionResponseDtoToJSON,
    IContributionSearchResponseInfoDtoFromJSON,
    IContributionSearchResponseInfoDtoToJSON,
    IContributionSegmentResponseDtoFromJSON,
    IContributionSegmentResponseDtoToJSON,
    IEntityAttributeDtoFromJSON,
    IEntityAttributeDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IPageChangesetChangeDtoFromJSON,
    IPageChangesetChangeDtoToJSON,
    IPayrollCalendarDtoFromJSON,
    IPayrollCalendarDtoToJSON,
    IPayrollCalendarExtendedDtoFromJSON,
    IPayrollCalendarExtendedDtoToJSON,
    IPayrollCalendarPartnerRequestDtoFromJSON,
    IPayrollCalendarPartnerRequestDtoToJSON,
    IPayrollCalendarReducedDtoFromJSON,
    IPayrollCalendarReducedDtoToJSON,
    IPayrollCalendarRequestDtoFromJSON,
    IPayrollCalendarRequestDtoToJSON,
    IPayrollCalendarResponseDtoFromJSON,
    IPayrollCalendarResponseDtoToJSON,
    IPayrollCalendarUpdateDtoFromJSON,
    IPayrollCalendarUpdateDtoToJSON,
    IPayrollCalendarUpdatePartnerRequestDtoFromJSON,
    IPayrollCalendarUpdatePartnerRequestDtoToJSON,
    IPayrollCalendarUpdatePartnerResponseDtoFromJSON,
    IPayrollCalendarUpdatePartnerResponseDtoToJSON,
    IPayrollGroupDtoFromJSON,
    IPayrollGroupDtoToJSON,
    IPayrollGroupPatchRequestDtoFromJSON,
    IPayrollGroupPatchRequestDtoToJSON,
    IPayrollGroupRequestDtoFromJSON,
    IPayrollGroupRequestDtoToJSON,
    IRecordTaxYearChangeCreateDtoFromJSON,
    IRecordTaxYearChangeCreateDtoToJSON,
    IRecordTaxYearChangeResponseDtoFromJSON,
    IRecordTaxYearChangeResponseDtoToJSON,
    IRecurringContributionResponseDtoFromJSON,
    IRecurringContributionResponseDtoToJSON,
    IScheduledCalendarDtoFromJSON,
    IScheduledCalendarDtoToJSON,
    IScheduledContributionRequestDtoFromJSON,
    IScheduledContributionRequestDtoToJSON,
    IScheduledContributionResponseDtoFromJSON,
    IScheduledContributionResponseDtoToJSON,
    IScheduledContributionUpdateDtoFromJSON,
    IScheduledContributionUpdateDtoToJSON,
} from '../models/index';

export interface AcceptContributionRequestRequest {
    iContributionRequestDto: IContributionRequestDto;
    oRGID?: string;
}

export interface CalculateScheduleRequest {
    startDate: Date;
    frequency: CalculateScheduleFrequencyEnum;
    calendarId?: number;
    dayOfWeek?: CalculateScheduleDayOfWeekEnum;
    firstDayOfMonth?: number;
    secondDayOfMonth?: number;
    month?: CalculateScheduleMonthEnum;
    dayOfMonth?: number;
}

export interface ContributionGetActivePayrollCalendarsByOrgIdRequest {
    organizationId: number;
}

export interface ContributionSearchContributionsRequest {
    submitDateFrom?: Date;
    submitDateTo?: Date;
    planCodes?: Set<string>;
    contributionSource?: Set<ContributionSearchContributionsContributionSourceEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface CreateContributionRecordTaxYearChangeRequest {
    iRecordTaxYearChangeCreateDto: IRecordTaxYearChangeCreateDto;
}

export interface CreateCustomScheduledDatesForCalendarRequest {
    id: number;
    requestBody: Set<Date>;
}

export interface CreatePayrollCalendarRequest {
    iPayrollCalendarRequestDto: IPayrollCalendarRequestDto;
}

export interface CreatePayrollCalendarByPartnerRequest {
    iPayrollCalendarPartnerRequestDto: IPayrollCalendarPartnerRequestDto;
}

export interface CreatePayrollGroupRequest {
    iPayrollGroupRequestDto: IPayrollGroupRequestDto;
}

export interface CreateScheduledContributionRequest {
    iScheduledContributionRequestDto: IScheduledContributionRequestDto;
}

export interface DeactivatePayrollCalendarRequest {
    id: number;
    requestBody: Set<number>;
}

export interface DeleteContributionRecordsRequest {
    requestId: string;
    ifMatch: number;
    requestBody: Array<number>;
}

export interface DeleteCustomScheduledDatesForCalendarRequest {
    id: number;
    requestBody: Set<Date>;
}

export interface GetActivePayrollCalendarById1Request {
    id: number;
}

export interface GetAttributesByChangesetIdRequest {
    changesetId: number;
}

export interface GetContributionActivityInfoRequest {
    contributionId?: string;
    statuses?: Set<GetContributionActivityInfoStatusesEnum>;
    planCodes?: Set<string>;
    taxYears?: Set<string>;
    employeeName?: string;
}

export interface GetContributionActivityInfo1Request {
    contributionId?: string;
    statuses?: Set<GetContributionActivityInfo1StatusesEnum>;
    planCodes?: Set<string>;
    taxYears?: Set<string>;
    employeeName?: string;
}

export interface GetContributionAmountDetailsV2Request {
    planCodes: Set<string>;
    employeeId: number;
}

export interface GetContributionRecordIdentifiersRequest {
    contributionRequestId: string;
    recordIds?: Set<number>;
}

export interface GetContributionRequestByIdRequest {
    contributionRequestId: string;
    recordData?: boolean;
}

export interface GetContributionSegmentRequest {
    contributionId: string;
}

export interface GetErrorRecordsCountRequest {
    requestId: string;
}

export interface GetLatestContributionRecordTaxYearChangeRequest {
    recordId: number;
}

export interface GetOrganizationPayrollGroups1Request {
    orgId: number;
}

export interface GetPayrollCalendarByOrgIdRequest {
    id: number;
}

export interface GetPayrollGroupByIdRequest {
    id: number;
}

export interface GetRecurringContributionByEmployeeIdRequest {
    employeeId?: number;
}

export interface GetScheduledDatesByCalendarIdRequest {
    id: number;
}

export interface SearchRequest {
    changesetId: number;
    fieldNames?: Array<string>;
    searchValue?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface UpdateContributionRequestStatusRequest {
    requestId: string;
    status: UpdateContributionRequestStatusStatusEnum;
}

export interface UpdatePayrollCalendar1Request {
    id: number;
    iPayrollCalendarUpdateDto: IPayrollCalendarUpdateDto;
}

export interface UpdatePayrollCalendarByPartnerRequest {
    calendarId: number;
    iPayrollCalendarUpdatePartnerRequestDto: IPayrollCalendarUpdatePartnerRequestDto;
}

export interface UpdatePayrollGroupRequest {
    id: number;
    iPayrollGroupPatchRequestDto: IPayrollGroupPatchRequestDto;
}

export interface UpdateScheduledContributionRequest {
    id: number;
    iScheduledContributionUpdateDto: IScheduledContributionUpdateDto;
}

export interface UpdateStatusRequest {
    id: number;
    status: UpdateStatusStatusEnum;
}

/**
 * ContributionServiceServiceApi - interface
 * 
 * @export
 * @interface ContributionServiceServiceApiInterface
 */
export interface ContributionServiceServiceApiInterface {
    /**
     * 
     * @summary Accept contribution request
     * @param {IContributionRequestDto} iContributionRequestDto 
     * @param {string} [oRGID] Create contribution request entity for partner with org id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    acceptContributionRequestRaw(requestParameters: AcceptContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionResponseDto>>;

    /**
     * Accept contribution request
     */
    acceptContributionRequest(requestParameters: AcceptContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionResponseDto>;

    /**
     * 
     * @summary Calculate schedule. Retrieve list of dates
     * @param {Date} startDate 
     * @param {'WEEKLY' | 'BI_WEEKLY' | 'MONTHLY' | 'SEMI_MONTHLY' | 'ANNUALLY'} frequency 
     * @param {number} [calendarId] 
     * @param {'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'} [dayOfWeek] required for WEEKLY/BI-WEEKLY
     * @param {number} [firstDayOfMonth] required for MONTHLY/SEMI-MONTHLY
     * @param {number} [secondDayOfMonth] required for SEMI-MONTHLY
     * @param {'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER'} [month] required for ANNUALLY
     * @param {number} [dayOfMonth] required for ANNUALLY
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    calculateScheduleRaw(requestParameters: CalculateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Date>>>;

    /**
     * Calculate schedule. Retrieve list of dates
     */
    calculateSchedule(requestParameters: CalculateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Date>>;

    /**
     * 
     * @summary Find list of scheduled contributions for the organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    contributionFindScheduledContributionsForOrganizationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledCalendarDto>>;

    /**
     * Find list of scheduled contributions for the organization
     */
    contributionFindScheduledContributionsForOrganization(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledCalendarDto>;

    /**
     * 
     * @summary Get active payroll calendars by organization id with active plans/payroll-groups depending on calendar group type
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    contributionGetActivePayrollCalendarsByOrgIdRaw(requestParameters: ContributionGetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarResponseDto>>>;

    /**
     * Get active payroll calendars by organization id with active plans/payroll-groups depending on calendar group type
     */
    contributionGetActivePayrollCalendarsByOrgId(requestParameters: ContributionGetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarResponseDto>>;

    /**
     * 
     * @summary Search Contribution Page
     * @param {Date} [submitDateFrom] 
     * @param {Date} [submitDateTo] 
     * @param {Set<string>} [planCodes] 
     * @param {Set<'FPS' | 'API' | 'UI' | 'RECURRING' | 'SCHEDULED'>} [contributionSource] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    contributionSearchContributionsRaw(requestParameters: ContributionSearchContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionSearchResponseInfoDto>>;

    /**
     * Search Contribution Page
     */
    contributionSearchContributions(requestParameters: ContributionSearchContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionSearchResponseInfoDto>;

    /**
     * 
     * @summary Create contribution record tax year change
     * @param {IRecordTaxYearChangeCreateDto} iRecordTaxYearChangeCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    createContributionRecordTaxYearChangeRaw(requestParameters: CreateContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Create contribution record tax year change
     */
    createContributionRecordTaxYearChange(requestParameters: CreateContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Create custom scheduled dates for specific calendar
     * @param {number} id 
     * @param {Set<Date>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    createCustomScheduledDatesForCalendarRaw(requestParameters: CreateCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Date>>>;

    /**
     * Create custom scheduled dates for specific calendar
     */
    createCustomScheduledDatesForCalendar(requestParameters: CreateCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Date>>;

    /**
     * 
     * @summary Create payroll calendar
     * @param {IPayrollCalendarRequestDto} iPayrollCalendarRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    createPayrollCalendarRaw(requestParameters: CreatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedDto>>;

    /**
     * Create payroll calendar
     */
    createPayrollCalendar(requestParameters: CreatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedDto>;

    /**
     * 
     * @summary Create payroll calendar by partner
     * @param {IPayrollCalendarPartnerRequestDto} iPayrollCalendarPartnerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    createPayrollCalendarByPartnerRaw(requestParameters: CreatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedDto>>;

    /**
     * Create payroll calendar by partner
     */
    createPayrollCalendarByPartner(requestParameters: CreatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedDto>;

    /**
     * 
     * @summary Create payroll group
     * @param {IPayrollGroupRequestDto} iPayrollGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    createPayrollGroupRaw(requestParameters: CreatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollGroupDto>>;

    /**
     * Create payroll group
     */
    createPayrollGroup(requestParameters: CreatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollGroupDto>;

    /**
     * 
     * @summary Create a ScheduledContribution
     * @param {IScheduledContributionRequestDto} iScheduledContributionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    createScheduledContributionRaw(requestParameters: CreateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionResponseDto>>;

    /**
     * Create a ScheduledContribution
     */
    createScheduledContribution(requestParameters: CreateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionResponseDto>;

    /**
     * 
     * @summary Deactivate payroll calendar
     * @param {number} id 
     * @param {Set<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    deactivatePayrollCalendarRaw(requestParameters: DeactivatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deactivate payroll calendar
     */
    deactivatePayrollCalendar(requestParameters: DeactivatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete contribution records for a request (batch)
     * @param {string} requestId 
     * @param {number} ifMatch Numeric version (ETag) of contribution request
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    deleteContributionRecordsRaw(requestParameters: DeleteContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete contribution records for a request (batch)
     * @deprecated
     */
    deleteContributionRecords(requestParameters: DeleteContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete specified custom scheduled dates from specific calendar
     * @param {number} id 
     * @param {Set<Date>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    deleteCustomScheduledDatesForCalendarRaw(requestParameters: DeleteCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete specified custom scheduled dates from specific calendar
     */
    deleteCustomScheduledDatesForCalendar(requestParameters: DeleteCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Active payroll calendar by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getActivePayrollCalendarById1Raw(requestParameters: GetActivePayrollCalendarById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedDto>>;

    /**
     * Get Active payroll calendar by id
     */
    getActivePayrollCalendarById1(requestParameters: GetActivePayrollCalendarById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedDto>;

    /**
     * 
     * @summary Get attributes for a changeset entity
     * @param {number} changesetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getAttributesByChangesetIdRaw(requestParameters: GetAttributesByChangesetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEntityAttributeDto>>>;

    /**
     * Get attributes for a changeset entity
     */
    getAttributesByChangesetId(requestParameters: GetAttributesByChangesetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEntityAttributeDto>>;

    /**
     * 
     * @summary Contribution Activity Page
     * @param {string} [contributionId] 
     * @param {Set<'INITIATED' | 'VALIDATED' | 'PROCESSING' | 'COMPLETED' | 'ERROR' | 'SKIPPED' | 'DECLINED'>} [statuses] 
     * @param {Set<string>} [planCodes] 
     * @param {Set<string>} [taxYears] 
     * @param {string} [employeeName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getContributionActivityInfoRaw(requestParameters: GetContributionActivityInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionActivityRecordResponseDto>>;

    /**
     * Contribution Activity Page
     */
    getContributionActivityInfo(requestParameters: GetContributionActivityInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionActivityRecordResponseDto>;

    /**
     * 
     * @summary Contribution activity csv report
     * @param {string} [contributionId] 
     * @param {Set<'INITIATED' | 'VALIDATED' | 'PROCESSING' | 'COMPLETED' | 'ERROR' | 'SKIPPED' | 'DECLINED'>} [statuses] 
     * @param {Set<string>} [planCodes] 
     * @param {Set<string>} [taxYears] 
     * @param {string} [employeeName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getContributionActivityInfo1Raw(requestParameters: GetContributionActivityInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionActivityRecordResponseDto>>;

    /**
     * Contribution activity csv report
     */
    getContributionActivityInfo1(requestParameters: GetContributionActivityInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionActivityRecordResponseDto>;

    /**
     * 
     * @summary Get contribution amounts by plan codes and employee id (v2)
     * @param {Set<string>} planCodes 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getContributionAmountDetailsV2Raw(requestParameters: GetContributionAmountDetailsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContributionAmountDetailsDto>>>;

    /**
     * Get contribution amounts by plan codes and employee id (v2)
     */
    getContributionAmountDetailsV2(requestParameters: GetContributionAmountDetailsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContributionAmountDetailsDto>>;

    /**
     * 
     * @summary Get contribution record identifiers by contribution request id
     * @param {string} contributionRequestId 
     * @param {Set<number>} [recordIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getContributionRecordIdentifiersRaw(requestParameters: GetContributionRecordIdentifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContributionRecordIdentifier>>>;

    /**
     * Get contribution record identifiers by contribution request id
     */
    getContributionRecordIdentifiers(requestParameters: GetContributionRecordIdentifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContributionRecordIdentifier>>;

    /**
     * 
     * @summary Get contribution request by id
     * @param {string} contributionRequestId 
     * @param {boolean} [recordData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getContributionRequestByIdRaw(requestParameters: GetContributionRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionResponseDto>>;

    /**
     * Get contribution request by id
     */
    getContributionRequestById(requestParameters: GetContributionRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionResponseDto>;

    /**
     * 
     * @summary Get contribution segment by ID
     * @param {string} contributionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getContributionSegmentRaw(requestParameters: GetContributionSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionSegmentResponseDto>>;

    /**
     * Get contribution segment by ID
     */
    getContributionSegment(requestParameters: GetContributionSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionSegmentResponseDto>;

    /**
     * 
     * @summary Get error records count for contribution request
     * @param {string} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getErrorRecordsCountRaw(requestParameters: GetErrorRecordsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>>;

    /**
     * Get error records count for contribution request
     */
    getErrorRecordsCount(requestParameters: GetErrorRecordsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number>;

    /**
     * 
     * @summary Get contribution record tax year change
     * @param {number} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getLatestContributionRecordTaxYearChangeRaw(requestParameters: GetLatestContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecordTaxYearChangeResponseDto>>;

    /**
     * Get contribution record tax year change
     */
    getLatestContributionRecordTaxYearChange(requestParameters: GetLatestContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecordTaxYearChangeResponseDto>;

    /**
     * 
     * @summary Get organization payroll group
     * @param {number} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getOrganizationPayrollGroups1Raw(requestParameters: GetOrganizationPayrollGroups1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollGroupDto>>>;

    /**
     * Get organization payroll group
     */
    getOrganizationPayrollGroups1(requestParameters: GetOrganizationPayrollGroups1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollGroupDto>>;

    /**
     * 
     * @summary Get active payroll calendars by organization id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getPayrollCalendarByOrgIdRaw(requestParameters: GetPayrollCalendarByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarReducedDto>>>;

    /**
     * Get active payroll calendars by organization id
     */
    getPayrollCalendarByOrgId(requestParameters: GetPayrollCalendarByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarReducedDto>>;

    /**
     * 
     * @summary Get active payroll calendars by organization path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getPayrollCalendarByOrgPathRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarReducedDto>>>;

    /**
     * Get active payroll calendars by organization path
     */
    getPayrollCalendarByOrgPath(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarReducedDto>>;

    /**
     * 
     * @summary Get payroll group by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getPayrollGroupByIdRaw(requestParameters: GetPayrollGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollGroupDto>>;

    /**
     * Get payroll group by id
     */
    getPayrollGroupById(requestParameters: GetPayrollGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollGroupDto>;

    /**
     * 
     * @summary Get ACTIVE or PAUSED recurring contribution by identity employee id
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getRecurringContributionByEmployeeIdRaw(requestParameters: GetRecurringContributionByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionResponseDto>>;

    /**
     * Get ACTIVE or PAUSED recurring contribution by identity employee id
     */
    getRecurringContributionByEmployeeId(requestParameters: GetRecurringContributionByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionResponseDto>;

    /**
     * 
     * @summary Retrieve list of scheduled dates for specific calendar
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    getScheduledDatesByCalendarIdRaw(requestParameters: GetScheduledDatesByCalendarIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Date>>>;

    /**
     * Retrieve list of scheduled dates for specific calendar
     */
    getScheduledDatesByCalendarId(requestParameters: GetScheduledDatesByCalendarIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Date>>;

    /**
     * 
     * @summary Search changes for a changeset
     * @param {number} changesetId 
     * @param {Array<string>} [fieldNames] 
     * @param {string} [searchValue] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    searchRaw(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageChangesetChangeDto>>;

    /**
     * Search changes for a changeset
     */
    search(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageChangesetChangeDto>;

    /**
     * 
     * @summary Update contribution status
     * @param {string} requestId 
     * @param {'PROCESSING' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'ERROR' | 'VALIDATION_FAILED' | 'APPROVAL_NEEDED' | 'REJECTED' | 'SUBMITTED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    updateContributionRequestStatusRaw(requestParameters: UpdateContributionRequestStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionSegmentResponseDto>>;

    /**
     * Update contribution status
     */
    updateContributionRequestStatus(requestParameters: UpdateContributionRequestStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionSegmentResponseDto>;

    /**
     * 
     * @summary Update payroll calendar
     * @param {number} id 
     * @param {IPayrollCalendarUpdateDto} iPayrollCalendarUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    updatePayrollCalendar1Raw(requestParameters: UpdatePayrollCalendar1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarDto>>;

    /**
     * Update payroll calendar
     */
    updatePayrollCalendar1(requestParameters: UpdatePayrollCalendar1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarDto>;

    /**
     * 
     * @summary Update payroll calendar
     * @param {number} calendarId 
     * @param {IPayrollCalendarUpdatePartnerRequestDto} iPayrollCalendarUpdatePartnerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    updatePayrollCalendarByPartnerRaw(requestParameters: UpdatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarUpdatePartnerResponseDto>>;

    /**
     * Update payroll calendar
     */
    updatePayrollCalendarByPartner(requestParameters: UpdatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarUpdatePartnerResponseDto>;

    /**
     * 
     * @summary Update payroll group
     * @param {number} id 
     * @param {IPayrollGroupPatchRequestDto} iPayrollGroupPatchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    updatePayrollGroupRaw(requestParameters: UpdatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollGroupDto>>;

    /**
     * Update payroll group
     */
    updatePayrollGroup(requestParameters: UpdatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollGroupDto>;

    /**
     * 
     * @summary Update calendar and tax type of a scheduled contribution
     * @param {number} id 
     * @param {IScheduledContributionUpdateDto} iScheduledContributionUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    updateScheduledContributionRaw(requestParameters: UpdateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionResponseDto>>;

    /**
     * Update calendar and tax type of a scheduled contribution
     */
    updateScheduledContribution(requestParameters: UpdateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionResponseDto>;

    /**
     * 
     * @summary Update the status of a scheduled contribution
     * @param {number} id 
     * @param {'ACTIVE' | 'SUSPENDED' | 'DEACTIVATED' | 'REMOVED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionServiceServiceApiInterface
     */
    updateStatusRaw(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionResponseDto>>;

    /**
     * Update the status of a scheduled contribution
     */
    updateStatus(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionResponseDto>;

}

/**
 * 
 */
export class ContributionServiceServiceApi extends runtime.BaseAPI implements ContributionServiceServiceApiInterface {

    /**
     * Accept contribution request
     */
    async acceptContributionRequestRaw(requestParameters: AcceptContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionResponseDto>> {
        if (requestParameters['iContributionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iContributionRequestDto',
                'Required parameter "iContributionRequestDto" was null or undefined when calling acceptContributionRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['oRGID'] != null) {
            headerParameters['ORG-ID'] = String(requestParameters['oRGID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IContributionRequestDtoToJSON(requestParameters['iContributionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Accept contribution request
     */
    async acceptContributionRequest(requestParameters: AcceptContributionRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionResponseDto> {
        const response = await this.acceptContributionRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculate schedule. Retrieve list of dates
     */
    async calculateScheduleRaw(requestParameters: CalculateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Date>>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling calculateSchedule().'
            );
        }

        if (requestParameters['frequency'] == null) {
            throw new runtime.RequiredError(
                'frequency',
                'Required parameter "frequency" was null or undefined when calling calculateSchedule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['calendarId'] != null) {
            queryParameters['calendar_id'] = requestParameters['calendarId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['frequency'] != null) {
            queryParameters['frequency'] = requestParameters['frequency'];
        }

        if (requestParameters['dayOfWeek'] != null) {
            queryParameters['day_of_week'] = requestParameters['dayOfWeek'];
        }

        if (requestParameters['firstDayOfMonth'] != null) {
            queryParameters['first_day_of_month'] = requestParameters['firstDayOfMonth'];
        }

        if (requestParameters['secondDayOfMonth'] != null) {
            queryParameters['second_day_of_month'] = requestParameters['secondDayOfMonth'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['dayOfMonth'] != null) {
            queryParameters['day_of_month'] = requestParameters['dayOfMonth'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/calculate-schedule`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Calculate schedule. Retrieve list of dates
     */
    async calculateSchedule(requestParameters: CalculateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Date>> {
        const response = await this.calculateScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find list of scheduled contributions for the organization
     */
    async contributionFindScheduledContributionsForOrganizationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledCalendarDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contributions/organization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IScheduledCalendarDtoFromJSON(jsonValue));
    }

    /**
     * Find list of scheduled contributions for the organization
     */
    async contributionFindScheduledContributionsForOrganization(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledCalendarDto> {
        const response = await this.contributionFindScheduledContributionsForOrganizationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get active payroll calendars by organization id with active plans/payroll-groups depending on calendar group type
     */
    async contributionGetActivePayrollCalendarsByOrgIdRaw(requestParameters: ContributionGetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarResponseDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling contributionGetActivePayrollCalendarsByOrgId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/organizations/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayrollCalendarResponseDtoFromJSON));
    }

    /**
     * Get active payroll calendars by organization id with active plans/payroll-groups depending on calendar group type
     */
    async contributionGetActivePayrollCalendarsByOrgId(requestParameters: ContributionGetActivePayrollCalendarsByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarResponseDto>> {
        const response = await this.contributionGetActivePayrollCalendarsByOrgIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search Contribution Page
     */
    async contributionSearchContributionsRaw(requestParameters: ContributionSearchContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionSearchResponseInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['submitDateFrom'] != null) {
            queryParameters['submit_date_from'] = (requestParameters['submitDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['submitDateTo'] != null) {
            queryParameters['submit_date_to'] = (requestParameters['submitDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['contributionSource'] != null) {
            queryParameters['contribution_source'] = requestParameters['contributionSource'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionSearchResponseInfoDtoFromJSON(jsonValue));
    }

    /**
     * Search Contribution Page
     */
    async contributionSearchContributions(requestParameters: ContributionSearchContributionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionSearchResponseInfoDto> {
        const response = await this.contributionSearchContributionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create contribution record tax year change
     */
    async createContributionRecordTaxYearChangeRaw(requestParameters: CreateContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iRecordTaxYearChangeCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iRecordTaxYearChangeCreateDto',
                'Required parameter "iRecordTaxYearChangeCreateDto" was null or undefined when calling createContributionRecordTaxYearChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/records/tax-years-change`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IRecordTaxYearChangeCreateDtoToJSON(requestParameters['iRecordTaxYearChangeCreateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create contribution record tax year change
     */
    async createContributionRecordTaxYearChange(requestParameters: CreateContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createContributionRecordTaxYearChangeRaw(requestParameters, initOverrides);
    }

    /**
     * Create custom scheduled dates for specific calendar
     */
    async createCustomScheduledDatesForCalendarRaw(requestParameters: CreateCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Date>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createCustomScheduledDatesForCalendar().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createCustomScheduledDatesForCalendar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{id}/scheduled-dates`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create custom scheduled dates for specific calendar
     */
    async createCustomScheduledDatesForCalendar(requestParameters: CreateCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Date>> {
        const response = await this.createCustomScheduledDatesForCalendarRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create payroll calendar
     */
    async createPayrollCalendarRaw(requestParameters: CreatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedDto>> {
        if (requestParameters['iPayrollCalendarRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPayrollCalendarRequestDto',
                'Required parameter "iPayrollCalendarRequestDto" was null or undefined when calling createPayrollCalendar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPayrollCalendarRequestDtoToJSON(requestParameters['iPayrollCalendarRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollCalendarExtendedDtoFromJSON(jsonValue));
    }

    /**
     * Create payroll calendar
     */
    async createPayrollCalendar(requestParameters: CreatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedDto> {
        const response = await this.createPayrollCalendarRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create payroll calendar by partner
     */
    async createPayrollCalendarByPartnerRaw(requestParameters: CreatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedDto>> {
        if (requestParameters['iPayrollCalendarPartnerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPayrollCalendarPartnerRequestDto',
                'Required parameter "iPayrollCalendarPartnerRequestDto" was null or undefined when calling createPayrollCalendarByPartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/partner`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPayrollCalendarPartnerRequestDtoToJSON(requestParameters['iPayrollCalendarPartnerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollCalendarExtendedDtoFromJSON(jsonValue));
    }

    /**
     * Create payroll calendar by partner
     */
    async createPayrollCalendarByPartner(requestParameters: CreatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedDto> {
        const response = await this.createPayrollCalendarByPartnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create payroll group
     */
    async createPayrollGroupRaw(requestParameters: CreatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollGroupDto>> {
        if (requestParameters['iPayrollGroupRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPayrollGroupRequestDto',
                'Required parameter "iPayrollGroupRequestDto" was null or undefined when calling createPayrollGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-groups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPayrollGroupRequestDtoToJSON(requestParameters['iPayrollGroupRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollGroupDtoFromJSON(jsonValue));
    }

    /**
     * Create payroll group
     */
    async createPayrollGroup(requestParameters: CreatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollGroupDto> {
        const response = await this.createPayrollGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a ScheduledContribution
     */
    async createScheduledContributionRaw(requestParameters: CreateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionResponseDto>> {
        if (requestParameters['iScheduledContributionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iScheduledContributionRequestDto',
                'Required parameter "iScheduledContributionRequestDto" was null or undefined when calling createScheduledContribution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contributions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IScheduledContributionRequestDtoToJSON(requestParameters['iScheduledContributionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IScheduledContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create a ScheduledContribution
     */
    async createScheduledContribution(requestParameters: CreateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionResponseDto> {
        const response = await this.createScheduledContributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate payroll calendar
     */
    async deactivatePayrollCalendarRaw(requestParameters: DeactivatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deactivatePayrollCalendar().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deactivatePayrollCalendar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivate payroll calendar
     */
    async deactivatePayrollCalendar(requestParameters: DeactivatePayrollCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivatePayrollCalendarRaw(requestParameters, initOverrides);
    }

    /**
     * Delete contribution records for a request (batch)
     * @deprecated
     */
    async deleteContributionRecordsRaw(requestParameters: DeleteContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling deleteContributionRecords().'
            );
        }

        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling deleteContributionRecords().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deleteContributionRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{request_id}/contribution-records`;
        urlPath = urlPath.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete contribution records for a request (batch)
     * @deprecated
     */
    async deleteContributionRecords(requestParameters: DeleteContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContributionRecordsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete specified custom scheduled dates from specific calendar
     */
    async deleteCustomScheduledDatesForCalendarRaw(requestParameters: DeleteCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCustomScheduledDatesForCalendar().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deleteCustomScheduledDatesForCalendar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{id}/scheduled-dates`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete specified custom scheduled dates from specific calendar
     */
    async deleteCustomScheduledDatesForCalendar(requestParameters: DeleteCustomScheduledDatesForCalendarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomScheduledDatesForCalendarRaw(requestParameters, initOverrides);
    }

    /**
     * Get Active payroll calendar by id
     */
    async getActivePayrollCalendarById1Raw(requestParameters: GetActivePayrollCalendarById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarExtendedDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getActivePayrollCalendarById1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollCalendarExtendedDtoFromJSON(jsonValue));
    }

    /**
     * Get Active payroll calendar by id
     */
    async getActivePayrollCalendarById1(requestParameters: GetActivePayrollCalendarById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarExtendedDto> {
        const response = await this.getActivePayrollCalendarById1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get attributes for a changeset entity
     */
    async getAttributesByChangesetIdRaw(requestParameters: GetAttributesByChangesetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEntityAttributeDto>>> {
        if (requestParameters['changesetId'] == null) {
            throw new runtime.RequiredError(
                'changesetId',
                'Required parameter "changesetId" was null or undefined when calling getAttributesByChangesetId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/audit/changesets/{changeset_id}/attributes`;
        urlPath = urlPath.replace(`{${"changeset_id"}}`, encodeURIComponent(String(requestParameters['changesetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEntityAttributeDtoFromJSON));
    }

    /**
     * Get attributes for a changeset entity
     */
    async getAttributesByChangesetId(requestParameters: GetAttributesByChangesetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEntityAttributeDto>> {
        const response = await this.getAttributesByChangesetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Contribution Activity Page
     */
    async getContributionActivityInfoRaw(requestParameters: GetContributionActivityInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionActivityRecordResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['contributionId'] != null) {
            queryParameters['contribution_id'] = requestParameters['contributionId'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['taxYears'] != null) {
            queryParameters['tax_years'] = requestParameters['taxYears'];
        }

        if (requestParameters['employeeName'] != null) {
            queryParameters['employee_name'] = requestParameters['employeeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/activity`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionActivityRecordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Contribution Activity Page
     */
    async getContributionActivityInfo(requestParameters: GetContributionActivityInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionActivityRecordResponseDto> {
        const response = await this.getContributionActivityInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Contribution activity csv report
     */
    async getContributionActivityInfo1Raw(requestParameters: GetContributionActivityInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionActivityRecordResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['contributionId'] != null) {
            queryParameters['contribution_id'] = requestParameters['contributionId'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['taxYears'] != null) {
            queryParameters['tax_years'] = requestParameters['taxYears'];
        }

        if (requestParameters['employeeName'] != null) {
            queryParameters['employee_name'] = requestParameters['employeeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/activity/csv-report`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionActivityRecordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Contribution activity csv report
     */
    async getContributionActivityInfo1(requestParameters: GetContributionActivityInfo1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionActivityRecordResponseDto> {
        const response = await this.getContributionActivityInfo1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contribution amounts by plan codes and employee id (v2)
     */
    async getContributionAmountDetailsV2Raw(requestParameters: GetContributionAmountDetailsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContributionAmountDetailsDto>>> {
        if (requestParameters['planCodes'] == null) {
            throw new runtime.RequiredError(
                'planCodes',
                'Required parameter "planCodes" was null or undefined when calling getContributionAmountDetailsV2().'
            );
        }

        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getContributionAmountDetailsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/v2/amounts/by-plan`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContributionAmountDetailsDtoFromJSON));
    }

    /**
     * Get contribution amounts by plan codes and employee id (v2)
     */
    async getContributionAmountDetailsV2(requestParameters: GetContributionAmountDetailsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContributionAmountDetailsDto>> {
        const response = await this.getContributionAmountDetailsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contribution record identifiers by contribution request id
     */
    async getContributionRecordIdentifiersRaw(requestParameters: GetContributionRecordIdentifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContributionRecordIdentifier>>> {
        if (requestParameters['contributionRequestId'] == null) {
            throw new runtime.RequiredError(
                'contributionRequestId',
                'Required parameter "contributionRequestId" was null or undefined when calling getContributionRecordIdentifiers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['recordIds'] != null) {
            queryParameters['record_ids'] = requestParameters['recordIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{contribution_request_id}/records-identifiers`;
        urlPath = urlPath.replace(`{${"contribution_request_id"}}`, encodeURIComponent(String(requestParameters['contributionRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContributionRecordIdentifierFromJSON));
    }

    /**
     * Get contribution record identifiers by contribution request id
     */
    async getContributionRecordIdentifiers(requestParameters: GetContributionRecordIdentifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContributionRecordIdentifier>> {
        const response = await this.getContributionRecordIdentifiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contribution request by id
     */
    async getContributionRequestByIdRaw(requestParameters: GetContributionRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionResponseDto>> {
        if (requestParameters['contributionRequestId'] == null) {
            throw new runtime.RequiredError(
                'contributionRequestId',
                'Required parameter "contributionRequestId" was null or undefined when calling getContributionRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['recordData'] != null) {
            queryParameters['record_data'] = requestParameters['recordData'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{contribution_request_id}`;
        urlPath = urlPath.replace(`{${"contribution_request_id"}}`, encodeURIComponent(String(requestParameters['contributionRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contribution request by id
     */
    async getContributionRequestById(requestParameters: GetContributionRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionResponseDto> {
        const response = await this.getContributionRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contribution segment by ID
     */
    async getContributionSegmentRaw(requestParameters: GetContributionSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionSegmentResponseDto>> {
        if (requestParameters['contributionId'] == null) {
            throw new runtime.RequiredError(
                'contributionId',
                'Required parameter "contributionId" was null or undefined when calling getContributionSegment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contributionId'] != null) {
            queryParameters['contribution_id'] = requestParameters['contributionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/segments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionSegmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contribution segment by ID
     */
    async getContributionSegment(requestParameters: GetContributionSegmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionSegmentResponseDto> {
        const response = await this.getContributionSegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get error records count for contribution request
     */
    async getErrorRecordsCountRaw(requestParameters: GetErrorRecordsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getErrorRecordsCount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{request_id}/error-records-count`;
        urlPath = urlPath.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get error records count for contribution request
     */
    async getErrorRecordsCount(requestParameters: GetErrorRecordsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getErrorRecordsCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contribution record tax year change
     */
    async getLatestContributionRecordTaxYearChangeRaw(requestParameters: GetLatestContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecordTaxYearChangeResponseDto>> {
        if (requestParameters['recordId'] == null) {
            throw new runtime.RequiredError(
                'recordId',
                'Required parameter "recordId" was null or undefined when calling getLatestContributionRecordTaxYearChange().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['recordId'] != null) {
            queryParameters['record_id'] = requestParameters['recordId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/records/tax-years-change`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRecordTaxYearChangeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contribution record tax year change
     */
    async getLatestContributionRecordTaxYearChange(requestParameters: GetLatestContributionRecordTaxYearChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecordTaxYearChangeResponseDto> {
        const response = await this.getLatestContributionRecordTaxYearChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get organization payroll group
     */
    async getOrganizationPayrollGroups1Raw(requestParameters: GetOrganizationPayrollGroups1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollGroupDto>>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling getOrganizationPayrollGroups1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-groups/organizations/{org-id}`;
        urlPath = urlPath.replace(`{${"org-id"}}`, encodeURIComponent(String(requestParameters['orgId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayrollGroupDtoFromJSON));
    }

    /**
     * Get organization payroll group
     */
    async getOrganizationPayrollGroups1(requestParameters: GetOrganizationPayrollGroups1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollGroupDto>> {
        const response = await this.getOrganizationPayrollGroups1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active payroll calendars by organization id
     */
    async getPayrollCalendarByOrgIdRaw(requestParameters: GetPayrollCalendarByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarReducedDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPayrollCalendarByOrgId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/organizations/{id}/reduced`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayrollCalendarReducedDtoFromJSON));
    }

    /**
     * Get active payroll calendars by organization id
     */
    async getPayrollCalendarByOrgId(requestParameters: GetPayrollCalendarByOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarReducedDto>> {
        const response = await this.getPayrollCalendarByOrgIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active payroll calendars by organization path
     */
    async getPayrollCalendarByOrgPathRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPayrollCalendarReducedDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/organizations/organization-path/reduced`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPayrollCalendarReducedDtoFromJSON));
    }

    /**
     * Get active payroll calendars by organization path
     */
    async getPayrollCalendarByOrgPath(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPayrollCalendarReducedDto>> {
        const response = await this.getPayrollCalendarByOrgPathRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get payroll group by id
     */
    async getPayrollGroupByIdRaw(requestParameters: GetPayrollGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollGroupDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPayrollGroupById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollGroupDtoFromJSON(jsonValue));
    }

    /**
     * Get payroll group by id
     */
    async getPayrollGroupById(requestParameters: GetPayrollGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollGroupDto> {
        const response = await this.getPayrollGroupByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ACTIVE or PAUSED recurring contribution by identity employee id
     */
    async getRecurringContributionByEmployeeIdRaw(requestParameters: GetRecurringContributionByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRecurringContributionResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/recurring-contributions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRecurringContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get ACTIVE or PAUSED recurring contribution by identity employee id
     */
    async getRecurringContributionByEmployeeId(requestParameters: GetRecurringContributionByEmployeeIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRecurringContributionResponseDto> {
        const response = await this.getRecurringContributionByEmployeeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve list of scheduled dates for specific calendar
     */
    async getScheduledDatesByCalendarIdRaw(requestParameters: GetScheduledDatesByCalendarIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Date>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getScheduledDatesByCalendarId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{id}/scheduled-dates`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve list of scheduled dates for specific calendar
     */
    async getScheduledDatesByCalendarId(requestParameters: GetScheduledDatesByCalendarIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Date>> {
        const response = await this.getScheduledDatesByCalendarIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search changes for a changeset
     */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageChangesetChangeDto>> {
        if (requestParameters['changesetId'] == null) {
            throw new runtime.RequiredError(
                'changesetId',
                'Required parameter "changesetId" was null or undefined when calling search().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fieldNames'] != null) {
            queryParameters['field_names'] = requestParameters['fieldNames'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/audit/changesets/{changeset_id}/search`;
        urlPath = urlPath.replace(`{${"changeset_id"}}`, encodeURIComponent(String(requestParameters['changesetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageChangesetChangeDtoFromJSON(jsonValue));
    }

    /**
     * Search changes for a changeset
     */
    async search(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageChangesetChangeDto> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update contribution status
     */
    async updateContributionRequestStatusRaw(requestParameters: UpdateContributionRequestStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionSegmentResponseDto>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling updateContributionRequestStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling updateContributionRequestStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{request_id}/status`;
        urlPath = urlPath.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionSegmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update contribution status
     */
    async updateContributionRequestStatus(requestParameters: UpdateContributionRequestStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionSegmentResponseDto> {
        const response = await this.updateContributionRequestStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update payroll calendar
     */
    async updatePayrollCalendar1Raw(requestParameters: UpdatePayrollCalendar1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePayrollCalendar1().'
            );
        }

        if (requestParameters['iPayrollCalendarUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iPayrollCalendarUpdateDto',
                'Required parameter "iPayrollCalendarUpdateDto" was null or undefined when calling updatePayrollCalendar1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPayrollCalendarUpdateDtoToJSON(requestParameters['iPayrollCalendarUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollCalendarDtoFromJSON(jsonValue));
    }

    /**
     * Update payroll calendar
     */
    async updatePayrollCalendar1(requestParameters: UpdatePayrollCalendar1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarDto> {
        const response = await this.updatePayrollCalendar1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update payroll calendar
     */
    async updatePayrollCalendarByPartnerRaw(requestParameters: UpdatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollCalendarUpdatePartnerResponseDto>> {
        if (requestParameters['calendarId'] == null) {
            throw new runtime.RequiredError(
                'calendarId',
                'Required parameter "calendarId" was null or undefined when calling updatePayrollCalendarByPartner().'
            );
        }

        if (requestParameters['iPayrollCalendarUpdatePartnerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPayrollCalendarUpdatePartnerRequestDto',
                'Required parameter "iPayrollCalendarUpdatePartnerRequestDto" was null or undefined when calling updatePayrollCalendarByPartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-calendars/{calendar-id}/partner`;
        urlPath = urlPath.replace(`{${"calendar-id"}}`, encodeURIComponent(String(requestParameters['calendarId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPayrollCalendarUpdatePartnerRequestDtoToJSON(requestParameters['iPayrollCalendarUpdatePartnerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollCalendarUpdatePartnerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update payroll calendar
     */
    async updatePayrollCalendarByPartner(requestParameters: UpdatePayrollCalendarByPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollCalendarUpdatePartnerResponseDto> {
        const response = await this.updatePayrollCalendarByPartnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update payroll group
     */
    async updatePayrollGroupRaw(requestParameters: UpdatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPayrollGroupDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePayrollGroup().'
            );
        }

        if (requestParameters['iPayrollGroupPatchRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPayrollGroupPatchRequestDto',
                'Required parameter "iPayrollGroupPatchRequestDto" was null or undefined when calling updatePayrollGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/payroll-groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IPayrollGroupPatchRequestDtoToJSON(requestParameters['iPayrollGroupPatchRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPayrollGroupDtoFromJSON(jsonValue));
    }

    /**
     * Update payroll group
     */
    async updatePayrollGroup(requestParameters: UpdatePayrollGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPayrollGroupDto> {
        const response = await this.updatePayrollGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update calendar and tax type of a scheduled contribution
     */
    async updateScheduledContributionRaw(requestParameters: UpdateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateScheduledContribution().'
            );
        }

        if (requestParameters['iScheduledContributionUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iScheduledContributionUpdateDto',
                'Required parameter "iScheduledContributionUpdateDto" was null or undefined when calling updateScheduledContribution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contributions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IScheduledContributionUpdateDtoToJSON(requestParameters['iScheduledContributionUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IScheduledContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update calendar and tax type of a scheduled contribution
     */
    async updateScheduledContribution(requestParameters: UpdateScheduledContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionResponseDto> {
        const response = await this.updateScheduledContributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the status of a scheduled contribution
     */
    async updateStatusRaw(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling updateStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contributions/{id}/status`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IScheduledContributionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update the status of a scheduled contribution
     */
    async updateStatus(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionResponseDto> {
        const response = await this.updateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum CalculateScheduleFrequencyEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
  * @export
  * @enum {string}
  */
export enum CalculateScheduleDayOfWeekEnum {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}
/**
  * @export
  * @enum {string}
  */
export enum CalculateScheduleMonthEnum {
    JANUARY = 'JANUARY',
    FEBRUARY = 'FEBRUARY',
    MARCH = 'MARCH',
    APRIL = 'APRIL',
    MAY = 'MAY',
    JUNE = 'JUNE',
    JULY = 'JULY',
    AUGUST = 'AUGUST',
    SEPTEMBER = 'SEPTEMBER',
    OCTOBER = 'OCTOBER',
    NOVEMBER = 'NOVEMBER',
    DECEMBER = 'DECEMBER'
}
/**
  * @export
  * @enum {string}
  */
export enum ContributionSearchContributionsContributionSourceEnum {
    FPS = 'FPS',
    API = 'API',
    UI = 'UI',
    RECURRING = 'RECURRING',
    SCHEDULED = 'SCHEDULED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetContributionActivityInfoStatusesEnum {
    INITIATED = 'INITIATED',
    VALIDATED = 'VALIDATED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    SKIPPED = 'SKIPPED',
    DECLINED = 'DECLINED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetContributionActivityInfo1StatusesEnum {
    INITIATED = 'INITIATED',
    VALIDATED = 'VALIDATED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    SKIPPED = 'SKIPPED',
    DECLINED = 'DECLINED'
}
/**
  * @export
  * @enum {string}
  */
export enum UpdateContributionRequestStatusStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    ERROR = 'ERROR',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    APPROVAL_NEEDED = 'APPROVAL_NEEDED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}
/**
  * @export
  * @enum {string}
  */
export enum UpdateStatusStatusEnum {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
    REMOVED = 'REMOVED'
}
